import React from "react";

function PrivacySecurityIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M36.89 25.327h-.238v-2.685c0-4.22-3.447-7.642-7.667-7.642s-7.666 3.422-7.666 7.612v2.685h-.238c-1.843 0-3.269 1.593-3.06 3.393l1.307 11.566A3.08 3.08 0 0022.388 43h13.254c1.575 0 2.912-1.18 3.06-2.744L39.98 28.72c.208-1.83-1.248-3.393-3.09-3.393zm-6.954 8.88l.387 3.482a.739.739 0 01-.743.826h-1.13a.739.739 0 01-.742-.826l.386-3.481a2.283 2.283 0 01-1.367-2.095 2.313 2.313 0 012.318-2.302 2.313 2.313 0 012.318 2.302c-.06.944-.624 1.74-1.427 2.095zm2.823-8.88h-7.548v-2.685c0-2.066 1.694-3.747 3.774-3.747s3.774 1.681 3.774 3.747v2.685z"
            ></path>
        </svg>
    );
}

export default PrivacySecurityIcon;
